<template>
  <v-container>
<v-row>
  <v-col cols="12" md="9">
    <component :is="currentComponent"  class="my-4"/>

  </v-col>
  <v-col cols="12" md="3">

  </v-col>
</v-row>
  </v-container>
</template>

<script setup>
import { inject, onMounted, computed,defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'


const route = useRoute();

const updateDocumentHead = inject('updateDocumentHead');




const currentComponent = computed(() => {
  const type = route.params.type;
  if (type) {
    return defineAsyncComponent(() =>
      import(`@/components/sites/objects/site/${type}Index.vue`)
    );
  }
  return null; // Fallback, falls id nicht vorhanden ist
});


onMounted(async () => {
  const type = route.params.type;
  if(type == 'Digitalausgabe'){
    updateDocumentHead(
      '  WaizmannTabelle | DigitalAusgabe für Ihre Zahnarzt Webseite',
      'WaizmannTabelle | DigitalAusgabe für Ihre Zahnarzt Webseite'
    ) 
  }
  if(type == 'Download'){
    updateDocumentHead(
      '  WaizmannTabelle | Download für Email-Versand',
      'WaizmannTabelle | Download für Email-Versand'
    ) 
  }
  if(type == 'Impressum'){
    updateDocumentHead(
      'Impressum | TeamWaizmann',
      'Impressum | TeamWaizmann'
    ) 
  }


})
</script>